<script>
  import CheckBox from "../../utils/CheckBox.svelte";
  import { saveSettings } from "../../api";
    import {SETTING_SAVE_TYPES} from "../../constants";
  import { PHP } from "../../store";
  import Message from "../../utils/Message.svelte";
  import to from "await-to-js";
  import ColorPicker from "../../utils/ColorPicker.svelte";

  export let submitSettings;

  let inprogress = false;
  
  let bellSettings = {
    isEnabled: JSON.parse($PHP.bellOptions.is_enabled || false),
    backgroundColor: $PHP.bellOptions.backgroundColor,
    bellColor: $PHP.bellOptions.bellColor,
  };

  let bellErrors = {
    isEnabled: ""
  };
  let showSuccessfulMessage = false;

  async function save(event) {
    inprogress = true;

    await to(
      submitSettings(SETTING_SAVE_TYPES.BELL, {
        is_enabled: bellSettings.isEnabled,
        backgroundColor: bellSettings.backgroundColor,
        bellColor: bellSettings.bellColor
      })
    );

    inprogress = false;
    showSuccessfulMessage = true;
    return false;
  }
</script>

<div class="container is-fluid">
  <Message
    message="Your change successfuly saved."
    type="is-success"
    show={showSuccessfulMessage} />
  <CheckBox
    title="Enable bell icon"
    bind:value={bellSettings.isEnabled}
    error={bellErrors.isEnabled}
    disabled={!$PHP.isActivated}
    tooltip={!$PHP.isActivated && 'First you need to activate the plugin'}
    isHorizontal />
  <ColorPicker title="Background Color" bind:color={bellSettings.backgroundColor} />
  <ColorPicker title="Bell Color" bind:color={bellSettings.bellColor} />
  <div class="buttons is-centered">
    <button
      class="button is-success is-outlined"
      on:click={save}
      class:is-loading={inprogress}
      disabled={inprogress}>
      Save
    </button>
  </div>
</div>
